module.exports = __webpack_public_path__ + "static/media/gameNft_select.aee5cbca.svg";